// Dokumenti kojima je knjizenje upisano automatski (prijedlog iz ranijih
// knjizenja partnera).
//
// Stoji izvan komponenti jer se stavke istog dokumenta prikazuju na dva mjesta
// - vodoravni popis (MainLedgerDetailList) i okomiti (MainLedgerDetailListVertical,
// kad racun ima pdf) - a popis se zna i ponovno stvoriti dok prvi primjerak jos
// ceka odgovor servera. Bez zajednicke oznake dokument bi se razradio dvaput.

const automatskiUpisani = new Set()

export const zabiljeziAutomatski = (id) => {
  if (id) { automatskiUpisani.add(id) }
}

export const jeAutomatski = (id) => !!id && automatskiUpisani.has(id)

export const zaboraviAutomatski = (id) => {
  automatskiUpisani.delete(id)
}

export default {zabiljeziAutomatski, jeAutomatski, zaboraviAutomatski}
